import { createContext } from 'react';

import type { Lucid } from '../../types/types';

const layoutContext: Lucid.Context.Layout = {
  abTesting: {
    updateTest: () => undefined,
  },
  shortCode: 'en',
  urlLangPrefix: '/',
  localeId: 'en',
  pageType: '',
  product: 'co',
  metatags: [],
};

export const layoutContextDefaults = layoutContext;

export default createContext(layoutContext);
